import { style } from '@vanilla-extract/css';

/**
 * Title column when a suffix (e.g. Beta pill) sits 8px (`gap="100"`) to its right:
 * stays content-sized when short, truncates when long, without pushing the suffix away.
 */
export const headerTitleAdjacentToSuffix = style(
  {
    minWidth: 0,
    overflow: 'hidden',
    flex: '0 1 auto',
    maxWidth: '100%',
  },
  'header-title-adjacent-to-suffix',
);
